<template>
  <div v-if="isVisible" class="loader-overlay">
    <div class="loader">
      <div class="lds-facebook"><div></div><div></div><div></div></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Loader",
    props: {
      isVisible: {type: Boolean, required: true},
      text: {type: String, required: false, default: ""},
    },
  }
</script>

<style lang="scss">
  .loader-overlay {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.7);
    z-index: 9999999;
    cursor: wait;
  }
  .loader {
    position: absolute;
    top: 50%;
    left: 50%;
    overflow: hidden;

    width: 200px;
    height: 200px;

    margin-top: -100px;
    margin-left: -100px;

    text-align: center;

    perspective: 600px;
  }

.lds-facebook {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}

.lds-facebook div {
  display: inline-block;
  position: absolute;
  left: 8px;
  width: 16px;
  background: #fff;
  animation: lds-facebook 1.2s cubic-bezier(0, 0.5, 0.5, 1) infinite;
}

.lds-facebook div:nth-child(1) {
  left: 8px;
  animation-delay: -0.24s;
  background: #1b347d;
}

.lds-facebook div:nth-child(2) {
  left: 32px;
  animation-delay: -0.12s;
  background: #1b347d;
}

.lds-facebook div:nth-child(3) {
  left: 56px;
  animation-delay: 0;
  background: #1b347d;
}

@keyframes lds-facebook {
  0% {
    top: 8px;
    height: 64px;
  }
  50%, 100% {
    top: 24px;
    height: 32px;
  }
}

</style>
